// src/components/TI.jsx
import { useState } from "react";
import Reveal from "./Reveal";

function Check() {
  return (
    <svg
      viewBox="0 0 20 20"
      className="mt-0.5 h-5 w-5 flex-none text-[#204B97]"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        fillRule="evenodd"
        d="M16.704 5.29a1 1 0 010 1.414l-7.2 7.2a1 1 0 01-1.414 0l-3-3a1 1 0 011.414-1.414l2.293 2.293 6.493-6.493a1 1 0 011.414 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default function TI() {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const fd = new FormData(e.currentTarget);
    const data = Object.fromEntries(fd.entries());

    try {
      const res = await fetch("/api/contact-ti.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      let ok = res.ok;
      let json = null;

      // Intentar leer JSON, pero no morir si viene texto plano
      try {
        json = await res.json();
        if (typeof json.ok !== "undefined") {
          ok = json.ok;
        }
      } catch (_) {
        // si no es JSON, simplemente ignoramos
      }

      if (!ok) {
        throw new Error(json?.error || "Error al enviar el formulario");
      }

      setSent(true);
      e.currentTarget.reset();
    } catch (err) {
      console.error(err);
      setError("Hubo un problema al enviar tu solicitud. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="ti" className="zen-bridge-dark">
      {/* class → className */}
      <div
        aria-hidden="true"
        className="h-px w-full bg-white/80 my-6"
      ></div>

      <div className="mx-auto max-w-7xl px-4 py-16">
        <Reveal>
          <div className="inline-flex items-center gap-2 rounded-full border border-[rgba(255, 255, 255, 0.08)] bg-white px-3 py-1 text-[12px] text-[#204B97]">
            Zentra Sistemas
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#36C0B9]" />
          </div>
          <h2 className="heading-display mt-4 text-4xl md:text-5xl font-bold text-white">
            Sistemas web a medida y Websites de alto rendimiento
          </h2>
          <p className="mt-3 max-w-2xl text-white/80">
            Diseñamos, desarrollamos e integramos soluciones escalables con foco
            en performance, seguridad y experiencia de usuario — alineadas a tus
            procesos y objetivos de negocio.
          </p>
        </Reveal>

        <div className="mt-10 grid gap-10 lg:grid-cols-2">
          {/* Columna izquierda igual que la tuya */}
          <div>
            <Reveal>
              <div className="rounded-2xl border border-[rgba(2,6,23,.08)] bg-white/90 p-6 shadow-sm transition hover:shadow-md">
                <h3 className="text-xl font-semibold text-slate-900">
                  ¿Qué hacemos?
                </h3>
                <p className="mt-2 text-slate-600">
                  Construimos{" "}
                  <strong className="text-slate-900">sistemas web</strong>{" "}
                  (portales, paneles internos, APIs) y{" "}
                  <strong className="text-slate-900">websites</strong> de marca
                  con UI moderna. Integramos ERPs/CRMs, pasarelas de pago y
                  terceros, con prácticas DevOps y monitoreo continuo.
                </p>

                <div className="mt-5 grid gap-4 sm:grid-cols-2">
                  <div className="rounded-xl border border-[rgba(2,6,23,.08)] bg-white p-4">
                    <p className="text-sm font-medium text-[#204B97]">
                      Sistemas Web
                    </p>
                    <ul className="mt-2 space-y-2 text-[15px] text-slate-700">
                      <li className="flex gap-2">
                        <Check /> Dashboards, workflows y reportes
                      </li>
                      <li className="flex gap-2">
                        <Check /> APIs REST/GraphQL
                      </li>
                      <li className="flex gap-2">
                        <Check /> Autenticación y roles
                      </li>
                    </ul>
                  </div>

                  <div className="rounded-xl border border-[rgba(2,6,23,.08)] bg-white p-4">
                    <p className="text-sm font-medium text-[#204B97]">
                      Websites
                    </p>
                    <ul className="mt-2 space-y-2 text-[15px] text-slate-700">
                      <li className="flex gap-2">
                        <Check /> UI/UX pro + animaciones
                      </li>
                      <li className="flex gap-2">
                        <Check /> SEO técnico y performance
                      </li>
                      <li className="flex gap-2">
                        <Check /> Landing pages que convierten
                      </li>
                    </ul>
                  </div>

                  <div className="rounded-xl border border-[rgba(2,6,23,.08)] bg-white p-4">
                    <p className="text-sm font-medium text-[#204B97]">
                      Integraciones
                    </p>
                    <ul className="mt-2 space-y-2 text-[15px] text-slate-700">
                      <li className="flex gap-2">
                        <Check /> Pagos, facturación electrónica
                      </li>
                      <li className="flex gap-2">
                        <Check /> ERPs/CRMs y servicios externos
                      </li>
                      <li className="flex gap-2">
                        <Check /> Webhooks y automatización
                      </li>
                    </ul>
                  </div>

                  <div className="rounded-xl border border-[rgba(2,6,23,.08)] bg-white p-4">
                    <p className="text-sm font-medium text-[#204B97]">
                      Operación
                    </p>
                    <ul className="mt-2 space-y-2 text-[15px] text-slate-700">
                      <li className="flex gap-2">
                        <Check /> DevOps + CI/CD
                      </li>
                      <li className="flex gap-2">
                        <Check /> Observabilidad y alertas
                      </li>
                      <li className="flex gap-2">
                        <Check /> Soporte y evolución
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="mt-6 flex flex-wrap items-center gap-3">
                  <span className="rounded-full bg-[#204B97] px-3 py-1 text-[12px] font-medium text-white">
                    React / Django / Tailwind
                  </span>
                  <span className="rounded-full bg-[#36C0B9] px-3 py-1 text-[12px] font-medium text-white">
                    API-first
                  </span>
                  <span className="rounded-full bg-[#5D83F3] px-3 py-1 text-[12px] font-medium text-white">
                    SEO & Performance
                  </span>
                </div>
              </div>
            </Reveal>
          </div>

          {/* Columna derecha: formulario */}
          <div>
            <Reveal delay={0.05}>
              <div className="rounded-2xl border border-[rgba(2,6,23,.10)] bg-white p-6 shadow-[0_10px_30px_rgba(2,8,23,.06)]">
                <h3 className="text-xl font-semibold text-slate-900">
                  Solicitar cotización
                </h3>
                <p className="mt-1.5 text-sm text-slate-600">
                  Cuéntanos tu proyecto y objetivos. Te responderemos con una
                  propuesta.
                </p>

                {sent ? (
                  <div
                    className="mt-6 rounded-xl border border-emerald-200 bg-emerald-50 p-4 text-emerald-800"
                    role="status"
                    aria-live="polite"
                  >
                    ✅ ¡Gracias! Recibimos tu solicitud. Te contactaremos a la
                    brevedad.
                  </div>
                ) : (
                  <form onSubmit={onSubmit} className="mt-5 space-y-4">
                    <div className="grid gap-4 sm:grid-cols-2">
                      <div>
                        <label className="text-sm font-medium text-slate-800">
                          Nombre
                        </label>
                        <input
                          name="nombre"
                          required
                          className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#204B97]/30"
                          placeholder="Tu nombre"
                        />
                      </div>
                      <div>
                        <label className="text-sm font-medium text-slate-800">
                          Email
                        </label>
                        <input
                          type="email"
                          name="email"
                          required
                          className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#204B97]/30"
                          placeholder="tucorreo@empresa.com"
                        />
                      </div>
                    </div>

                    <div className="grid gap-4 sm:grid-cols-2">
                      <div>
                        <label className="text-sm font-medium text-slate-800">
                          Teléfono
                        </label>
                        <input
                          name="telefono"
                          className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#204B97]/30"
                          placeholder="+56 9 1234 5678"
                        />
                      </div>
                      <div>
                        <label className="text-sm font-medium text-slate-800">
                          Empresa
                        </label>
                        <input
                          name="empresa"
                          className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#204B97]/30"
                          placeholder="Nombre de tu empresa"
                        />
                      </div>
                    </div>

                    <div className="grid gap-4 sm:grid-cols-2">
                      <div>
                        <label className="text-sm font-medium text-slate-800">
                          Tipo de proyecto
                        </label>
                        <select
                          name="tipo"
                          required
                          className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#204B97]/30"
                        >
                          <option value="">Selecciona…</option>
                          <option>Sistema web</option>
                          <option>Website corporativo</option>
                          <option>Landing Page</option>
                          <option>Integración/API</option>
                          <option>Soporte/Mantenimiento</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="text-sm font-medium text-slate-800">
                        Objetivos / Alcance
                      </label>
                      <textarea
                        name="mensaje"
                        required
                        rows={4}
                        className="mt-1 w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-[#204B97]/30"
                        placeholder="Cuéntanos qué necesitas, plazos, integraciones, etc."
                      />
                    </div>

                    {error && (
                      <p className="text-sm text-red-600">{error}</p>
                    )}

                    <div className="flex items-center justify-between gap-3">
                      <p className="text-[12px] text-slate-500">
                        Al enviar aceptas ser contactado/a respecto a tu
                        solicitud.
                      </p>

                      <button
                        type="submit"
                        disabled={loading}
                        className="rounded-xl bg-[#204B97] px-5 py-2.5 text-white shadow-sm hover:bg-[#1b3f80] focus:outline-none focus:ring-2 focus:ring-[#204B97]/30 disabled:opacity-60 disabled:cursor-not-allowed"
                      >
                        {loading ? "Enviando..." : "Enviar"}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
